import { createFileRoute } from '@tanstack/react-router'
import StaffPage from '@/pages/staff'

export const Route = createFileRoute('/staff')({
  component: StaffPage,
})
